"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useApplyForRefundLegacyMutation = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var core_1 = require("../../../core");
var use_refund_eligibility_query_1 = require("./use-refund-eligibility-query");
function useApplyForRefundLegacyMutation(accountId, customerId, onSuccess, onError) {
    var invalidateCache = (0, use_refund_eligibility_query_1.useInvalidateRefundEligibilityCheckLegacyQuery)(accountId);
    var api = core_1.configService.getConfig().api;
    var url = "".concat(api.baseUrl, "/pace-self-serve-refunds/v1/accounts/").concat(accountId, "/owners/").concat(customerId, "/refunds");
    return (0, ui_tools_1.useReactMutation)(function (_a) {
        var amount = _a.amount;
        return core_1.apiService.post({
            responseType: 'json',
            url: url,
            body: { amount: amount },
        });
    }, {
        onSuccess: function () {
            invalidateCache();
            if (onSuccess) {
                onSuccess();
            }
        },
        onError: function (error) {
            if (onError) {
                onError(error);
            }
        },
    });
}
exports.useApplyForRefundLegacyMutation = useApplyForRefundLegacyMutation;
